import { PDFFeatureAnalysisTableConfigs } from "@pages/platform-analysis/components/buttons/export-pdf/components/sections/feature-analysis/configs";

export class PDFBusinessAnalysisTableConfigs extends PDFFeatureAnalysisTableConfigs {}
